import { useEffect, useRef, useState } from "react";
import { IServiceForSubCategory } from "../screens/product-services/Web/ProductServiceDetailsWebController";
import {
  fetchPublicServiceByIdApi,
  fetchPublicServiceRatingsByIdApi,
} from "../public/offerings/OfferingController";
import ICPureImage from "../core-component/ICPureImage";
import {
  cancelIcon,
  clockIcon,
  darkStarIcon,
  rupeeIcon,
  straightLineIcon,
} from "../assets/icons/SvgIconList";
import UseTranslationHook from "../hooks/UseTranslationHook";
import CustomEditor from "../screens/product-services/Web/CustomEditor";
import { userRoute } from "../routes/RouteUser";
import { useNavigate } from "react-router-dom";
import UseMobileLayoutHook from "../hooks/UseMobileLayoutHook";
import { localStorageUtils } from "../utils/LocalStorageUtil";
import { publicRoute } from "../routes/RoutePublic";
import { DEVICE_TYPES } from "../utils/AppEnumerations";
import UsePublicDeviceTypeHook from "../hooks/UsePublicMobileLayoutHook";

interface IModalProps {
  id: number;
  closeModal: () => void;
}
interface IReviewComment {
  review_given_by: string;
  ratings: number;
  review_date: string;
  comments: string;
}

interface IStarWiseReview {
  rating: number;
  no_of_ratings: number;
}

export interface IServiceReview {
  service_id: number;
  average_rating: string;
  total_reviews: number;
  review_comments: IReviewComment[];
  star_wise_review: IStarWiseReview[];
}

const Modal: React.FC<IModalProps> = ({ id, closeModal }) => {
  const [publicService, setPublicService] =
    useState<IServiceForSubCategory | null>(null);
  const [ratings, setRatings] = useState<IServiceReview[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { t } = UseTranslationHook();
  useEffect(() => {
    fetchPublicServiceByIdApi(setPublicService, setLoading, id);
    fetchPublicServiceRatingsByIdApi(setRatings, setLoading, id);
  }, [id]);
  const scrollRef = useRef<HTMLDivElement>(null);
  const { deviceType } = UsePublicDeviceTypeHook();
  useEffect(() => {
    if (deviceType === DEVICE_TYPES.Mobile) {
      if (scrollRef.current) {
        const interval = setInterval(() => {
          if (scrollRef.current) {
            scrollRef.current.scrollLeft += 1;
          }
        }, 40);

        return () => clearInterval(interval);
      }
    } else if (deviceType === DEVICE_TYPES.Tablet) {
      if (scrollRef.current) {
        const interval = setInterval(() => {
          if (scrollRef.current) {
            scrollRef.current.scrollLeft += 1;
          }
        }, 40);

        return () => clearInterval(interval);
      }
    } else {
      if (scrollRef.current) {
        const interval = setInterval(() => {
          if (scrollRef.current) {
            scrollRef.current.scrollTop += 1;
          }
        }, 40);

        return () => clearInterval(interval);
      }
    }
  }, [publicService]);
  const sessionKey = localStorageUtils.getAccessToken();
  return (
    <div className="fixed inset-0 bg-opacity-50 flex justify-center items-center z-[999]">
      <div className="bg-skin-insights-card p-2 text-skin-insights h-full w-full mx-auto transition-transform animate-slide-up">
        <button
          className=" z-[999] flex justify-end w-full text-2xl  p-3"
          onClick={closeModal}
        >
          <div className="w-8 h-8">{cancelIcon}</div>
        </button>
        <div className="lg:grid lg:grid-cols-2 flex flex-col h-screen w-full ">
          <div
            className="lg:h-screen items-center w-full flex lg:flex-col aspect-16/9 lg:overflow-y-scroll remove-scrollbar-width overflow-y-hidden overflow-x-scroll lg:overflow-x-auto"
            ref={scrollRef}
          >
            {publicService &&
              publicService.app_media.length > 0 &&
              publicService.app_media.map((item, index) => (
                <div className="w-full h-full lg:mb-16 mb-0 mr-4" key={index}>
                  <ICPureImage
                    imageUrl={item.media_url}
                    wrapperClassName="aspect-16/9 h-full w-full"
                    className="aspect-16/9 w-full"
                  />
                </div>
              ))}
          </div>
          <div className="flex flex-col p-3 tracking-widest h-screen overflow-y-scroll overflow-x-hidden">
            <div className="text-4xl text-skin-insights">
              {publicService?.service_title}
            </div>
            <div className="flex mt-4">
              {ratings &&
                ratings.length > 0 &&
                ratings.map((item, index) => (
                  <div key={index} className="flex">
                    <div className="w-5 h-5 mr-3">{darkStarIcon}</div>
                    <div className="mr-2">{item.average_rating}</div>
                    <div> ({item.total_reviews})</div>
                  </div>
                ))}
            </div>

            <div className="flex items-center mt-6 w-full">
              <div className="flex items-center lg:w-1/4 w-full">
                <div className="w-10 h-10 bg-skin-home-slide mr-3 rounded-lg p-2">
                  {clockIcon}
                </div>
                <div className="text-skin-insights text-lg">
                  {" "}
                  {publicService?.service_duration}{" "}
                  {publicService?.interval_unit_types?.unit_type_text}
                </div>
              </div>
              <div className="mx-4 w-6 !h-6">{straightLineIcon}</div>
              <div className="flex items-center w-full">
                <div className="w-10 h-10 bg-skin-home-slide mr-3 rounded-lg p-3">
                  {rupeeIcon}
                </div>
                <div className="text-skin-insights text-lg">
                  {publicService?.service_discounted_price ? (
                    <>
                      <p className="mx-2">
                        {`${publicService.service_discounted_price}`.replace(
                          "$",
                          ""
                        )}
                      </p>
                      <p className="mx-2 comman-grey line-through">
                        {`${publicService.service_cost}`.replace("$", "")}
                      </p>
                    </>
                  ) : (
                    <p className="mx-2">
                      {`${publicService?.service_cost}`.replace("$", "")}
                    </p>
                  )}{" "}
                </div>
              </div>
            </div>
            <div className="flex mt-6 justify-items-end xl:justify-end lg:justify-end xl:w-full lg:w-full items-end">
              <div
                className="bg-skin-book-slot-button text-skin-insights p-3 rounded-lg flex justify-end text-2xl cursor-pointer"
                onClick={() =>
                  sessionKey
                    ? navigate(userRoute.slotBooking, { state: { id: id } })
                    : navigate("/" + publicRoute.login)
                }
              >
                {t("book_slot")}
              </div>
            </div>
            {publicService?.service_params &&
              publicService?.service_params.length > 0 && (
                <div className="flex mt-6">
                  <div className="w-full">
                    <div className="flex overflow-x-scroll">
                      {publicService.service_params.map(
                        (param: { [key: string]: string }, index: number) => {
                          const key = Object.keys(param)[0];
                          const value = param[key];
                          return (
                            <div
                              className="w-fit mr-5 bg-skin-home-slide rounded-xl flex flex-col p-3"
                              key={index}
                            >
                              <p className="mb-2.5 text-gray-500">{key}</p>
                              <p className="text-black text-lg text-nowrap">
                                {value}
                              </p>
                            </div>
                          );
                        }
                      )}
                    </div>
                  </div>
                </div>
              )}
            <div className="mt-6">
              {publicService?.service_desc &&
                publicService?.service_desc.length > 0 && (
                  <div>
                    {publicService?.service_desc && (
                      <>
                        <h1 className="text-4xl font-bold">
                          {t("description")}
                        </h1>
                        <div className="mt-3">
                          <p className=" text-justify">
                            <CustomEditor
                              serviceDesc={publicService?.service_desc}
                              containerClassName="!text-skin-insights !text-xl !leading-12"
                            />
                          </p>
                        </div>
                      </>
                    )}
                  </div>
                )}
            </div>
            <div className="flex mt-3 w-full justify-start flex-wrap">
              {publicService?.service_tags &&
                publicService?.service_tags.length > 0 &&
                publicService?.service_tags?.map((tag, index) => (
                  <div
                    key={index}
                    className="bg-skin-tag-insights-details text-skin-tag-insights-details px-2 py-1 rounded-full mr-2 mb-4"
                  >
                    {tag}
                  </div>
                ))}
            </div>
            <div className="mt-6">
              {publicService?.service_pros &&
                publicService?.service_pros.length > 0 && (
                  <div>
                    {publicService?.service_pros && (
                      <>
                        <h1 className="text-4xl font-bold">{t("benefits")}</h1>
                        <div className="mt-3">
                          {publicService?.service_pros && (
                            <ul>
                              {publicService?.service_pros.map(
                                (data, index) => (
                                  <li key={index} className="">
                                    {data}
                                  </li>
                                )
                              )}
                            </ul>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                )}
            </div>
            <div className="mt-6">
              {publicService?.service_other_notes &&
                publicService?.service_other_notes.length > 0 && (
                  <div>
                    {publicService?.service_other_notes && (
                      <>
                        <h1 className="text-4xl font-bold">{t("notes")}</h1>
                        <div className="mt-3">
                          {publicService?.service_other_notes && (
                            <ul>
                              {publicService?.service_other_notes.map(
                                (data, index) => (
                                  <li key={index} className="">
                                    {data}
                                  </li>
                                )
                              )}
                            </ul>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                )}
            </div>
            <div className="mt-6">
              {publicService?.service_pros &&
                publicService?.service_pros.length > 0 && (
                  <div>
                    {publicService?.service_precautions && (
                      <>
                        <h1 className="text-4xl font-bold">
                          {t("precautions")}
                        </h1>
                        <div className="mt-3 mb-12">
                          {publicService?.service_precautions && (
                            <ul>
                              {publicService?.service_precautions.map(
                                (data, index) => (
                                  <li key={index} className="">
                                    {data}
                                  </li>
                                )
                              )}
                            </ul>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
